<template>
  <div>
    <PageAppBar>TBD Admin</PageAppBar>
    <div class="page-content header-clear-small">
      <router-link to="/admin/users">
        <div class="card card-style mb-3">
          <div class="d-flex">
            <div class="pl-3 ml-2 align-self-center">
              <h1 class="pt-4">User Management</h1>
              <p class="font-11 opacity-50 mt-n2 mb-4">For all your Payment Purchases</p>
            </div>
            <div class="ml-auto mr-4 align-self-center">
              <i class="fa fa-credit-card color-blue2-dark fa-3x mt-4 mb-4"></i>
            </div>
          </div>
        </div>
      </router-link>

      <router-link to="/admin/list/farming">
        <div class="card card-style mb-3">
          <div class="d-flex">
            <div class="pl-3 ml-2 align-self-center">
              <h1 class="pt-4">Farming Project Management</h1>
              <p class="font-11 opacity-50 mt-n2 mb-4">For all your Payment Purchases</p>
            </div>
            <div class="ml-auto mr-4 align-self-center">
              <i class="fa fa-credit-card color-blue2-dark fa-3x mt-4 mb-4"></i>
            </div>
          </div>
        </div>
      </router-link>
      <router-link to="/admin/list/round">
        <div class="card card-style mb-3">
          <div class="d-flex">
            <div class="pl-3 ml-2 align-self-center">
              <h1 class="pt-4">Round Management</h1>
              <p class="font-11 opacity-50 mt-n2 mb-4">For all your Payment Purchases</p>
            </div>
            <div class="ml-auto mr-4 align-self-center">
              <i class="fa fa-credit-card color-blue2-dark fa-3x mt-4 mb-4"></i>
            </div>
          </div>
        </div>
      </router-link>
      <router-link to="/admin/list/stand">
        <div class="card card-style mb-3">
          <div class="d-flex">
            <div class="pl-3 ml-2 align-self-center">
              <h1 class="pt-4">Stands Management</h1>
              <p class="font-11 opacity-50 mt-n2 mb-4">For all your Payment Purchases</p>
            </div>
            <div class="ml-auto mr-4 align-self-center">
              <i class="fa fa-credit-card color-blue2-dark fa-3x mt-4 mb-4"></i>
            </div>
          </div>
        </div>
      </router-link>
      <router-link to="/admin/list/investment">
        <div class="card card-style mb-3">
          <div class="d-flex">
            <div class="pl-3 ml-2 align-self-center">
              <h1 class="pt-4">Investments Management</h1>
              <p class="font-11 opacity-50 mt-n2 mb-4">For all your Payment Purchases</p>
            </div>
            <div class="ml-auto mr-4 align-self-center">
              <i class="fa fa-credit-card color-blue2-dark fa-3x mt-4 mb-4"></i>
            </div>
          </div>
        </div>
      </router-link>
  </div>
  </div>
</template>

<script>
import PageAppBar from "@/components/PageAppBar";
export default {
name: "Dashboard",
  components: {PageAppBar}
}
</script>

<style scoped>

</style>